import { jsx as _jsx } from "react/jsx-runtime";
import { InstructionElement } from './InstructionElement';
import { t } from '../../../../../../infra/i18n';
export var PlatformNotSelectedInstructions = function () { return (_jsx(InstructionElement, { children: t('admin:external_platforms.platform_not_selected') })); };
